<div class="flex flex-col max-h-[85vh] overflow-hidden rounded-2xl bg-white dark:bg-zinc-900" [overlayLoader]="loading">
  <div class="flex items-center justify-between shrink-0 px-6 py-4 bg-primary text-white shadow-sm">
    <div class="flex items-center gap-x-2 min-w-0">
      <mat-icon class="icon-size-5 !text-white" [svgIcon]="'heroicons_outline:key'"></mat-icon>
      <div class="min-w-0">
        <h2 class="text-lg font-semibold !text-white truncate">Change Password</h2>
        <p class="text-xs text-white/80 truncate">Update your password while signed in</p>
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      class="shrink-0 !text-white hover:!bg-white/10"
      (click)="cancel()"
      [disabled]="loading"
      aria-label="Close"
    >
      <mat-icon class="!text-white" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
  </div>

  <div class="px-5 py-4 flex-1 overflow-y-auto" mat-dialog-content>
    <form [formGroup]="form" class="flex flex-col gap-1" (ngSubmit)="submit()">
      <mat-form-field class="fuse-mat-dense w-full">
        <mat-label>Current password</mat-label>
        <input
          matInput
          type="password"
          formControlName="currentPassword"
          #currentPasswordField
          autocomplete="current-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="
            currentPasswordField.type =
              currentPasswordField.type === 'password' ? 'text' : 'password'
          "
        >
          <mat-icon
            [svgIcon]="
              currentPasswordField.type === 'password'
                ? 'heroicons_solid:eye'
                : 'heroicons_solid:eye-slash'
            "
          ></mat-icon>
        </button>
        @if (form.get('currentPassword')?.hasError('required') && form.get('currentPassword')?.touched) {
          <mat-error>Current password is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="fuse-mat-dense w-full">
        <mat-label>New password</mat-label>
        <input
          matInput
          type="password"
          formControlName="newPassword"
          #newPasswordField
          autocomplete="new-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="
            newPasswordField.type =
              newPasswordField.type === 'password' ? 'text' : 'password'
          "
        >
          <mat-icon
            [svgIcon]="
              newPasswordField.type === 'password'
                ? 'heroicons_solid:eye'
                : 'heroicons_solid:eye-slash'
            "
          ></mat-icon>
        </button>
        @if (form.get('newPassword')?.hasError('required') && form.get('newPassword')?.touched) {
          <mat-error>New password is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="fuse-mat-dense w-full">
        <mat-label>Confirm new password</mat-label>
        <input
          matInput
          type="password"
          formControlName="confirmPassword"
          #confirmPasswordField
          autocomplete="new-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="
            confirmPasswordField.type =
              confirmPasswordField.type === 'password' ? 'text' : 'password'
          "
        >
          <mat-icon
            [svgIcon]="
              confirmPasswordField.type === 'password'
                ? 'heroicons_solid:eye'
                : 'heroicons_solid:eye-slash'
            "
          ></mat-icon>
        </button>
        @if (form.get('confirmPassword')?.hasError('required') && form.get('confirmPassword')?.touched) {
          <mat-error>Password confirmation is required</mat-error>
        }
        @if (form.get('confirmPassword')?.hasError('mustMatch') && form.get('confirmPassword')?.touched) {
          <mat-error>Passwords must match</mat-error>
        }
      </mat-form-field>

      <div
        class="mt-1 flex items-start gap-3 rounded-lg border border-neutral-200 px-3 py-3 dark:border-zinc-700"
        [ngClass]="{
          'border-primary-300 bg-primary-50 dark:bg-primary-900/20': form.get('logoutAllDevices')?.value
        }"
      >
        <mat-checkbox color="primary" formControlName="logoutAllDevices" class="mt-0.5"></mat-checkbox>
        <div class="min-w-0">
          <div class="text-sm font-medium text-zinc-900 dark:text-zinc-100">
            Log out from all devices
          </div>
          <div class="text-xs text-slate-500 dark:text-zinc-400 mt-0.5">
            Ends every active session for this account, including this one. You will need to sign in again.
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="flex items-center justify-end gap-2 shrink-0 border-t border-neutral-200 bg-zinc-50 px-5 py-3 dark:border-zinc-700 dark:bg-zinc-900/50">
    <button mat-stroked-button type="button" (click)="cancel()" [disabled]="loading">
      Cancel
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="submit()"
      [disabled]="loading || form.invalid"
    >
      <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:check'"></mat-icon>
      <span class="ms-1">{{ loading ? 'Saving…' : 'Change Password' }}</span>
    </button>
  </div>
</div>
